import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-muted px-5 py-20 sm:py-28" data-id="element-80" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-81" data-mp="1ge0fampoeud2">
        <div className="text-center" data-id="element-82" data-mp="1gauu3ik64cmm">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-success" data-id="element-83" data-mp="2e0pnjeaz237d">
            Vous avez encore des doutes&nbsp;?
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.6rem]" data-id="element-84" data-mp="28zikfsjrxs71">
            Questions <span className="italic text-emphasis" data-id="element-85" data-mp="1z25fxlb1dz7n">Fréquentes</span>
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-86" data-mp="snd49skgroma">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-surface" data-id="element-87" data-mp="nqd1prmtp3zx" data-mpi={index}>
                <h3 data-id="element-88" data-mp="pipjnt59e328">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-success/40" data-id="element-89" data-mp="uh0w8bmxuro5">
                    <span className="text-sm font-bold text-foreground" data-id="element-90" data-mp="6pvji5caofi2">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-success transition-transform duration-200 ease-out-strong ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-91" data-mp="biyemhwpzx0d" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-92" data-mp="3k02vemlafy3s">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-93" data-mp="3nys80cyi5bmd">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-foreground/60" data-id="element-94" data-mp="1fsq1mlpxho4m">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}